/**
 * Created by Jerker Nord on 2024-05-06.
 */
import {LonerDuckSymbol} from "./LonerDuckSymbol";
import {SpineUtils} from "../../../../utils/SpineUtils";
import {LonerSpine} from "../../../../components/LonerSpine";
import {Loner} from "../../../../Loner";
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {gsap} from "gsap";
import {LonerDuckAnimator} from "../LonerDuckAnimator";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

enum CLIP_DUCK_ANIMATION_NAMES {
    attention = "glow"
}

enum CLIP_DUCK_SKIN_NAMES {
    left = "CLIP_left",
    right = "CLIP_right",
    left_burnt = "CLIP_left_burn",
    right_burnt = "CLIP_right_burn"
}

export class LonerDuckClipSymbol extends LonerDuckSymbol {

    private _clipSpine: LonerSpine;

    constructor() {
        super();
    }

    protected init(): void {
        super.init();

        this._clipSpine = new LonerSpine(Loner.assetLoader.getSpineAsset(LonerGameAssets.CLIP_DUCK_SPINE));
        this._clipSpine.visible = false;
        this.addChild(this._clipSpine);

        this._symbolSprite.visible = false;
    }

    public startSymbolSpine(textureName: string): void {
        this._clipSpine.visible = true;
        if (textureName.indexOf("left") > -1) {
            this._clipSpine.skeleton.setSkinByName(CLIP_DUCK_SKIN_NAMES.left);
        } else {
            this._clipSpine.skeleton.setSkinByName(CLIP_DUCK_SKIN_NAMES.right);
        }
        SpineUtils.resetSpineAnimation(this._clipSpine);
        this._clipSpine.state.setAnimation(0, CLIP_DUCK_ANIMATION_NAMES.attention, true);
    }

    public getSymbolBurntTL(): gsap.core.Timeline {
        const burntTL: gsap.core.Timeline = gsap.timeline();
        if (this.isShot == true) {
            return burntTL;
        }

        burntTL.add(()=>{
            if (this.direction == LonerDuckAnimator.DIRECTION_LEFT) {
                this._clipSpine.skeleton.setSkinByName(CLIP_DUCK_SKIN_NAMES.left_burnt);
            } else {
                this._clipSpine.skeleton.setSkinByName(CLIP_DUCK_SKIN_NAMES.right_burnt);
            }
            SpineUtils.resetSpineAnimation(this._clipSpine);
            this._clipSpine.state.setAnimation(0, CLIP_DUCK_ANIMATION_NAMES.attention, true);
        });

        return burntTL;
    }

    public setSymbol(textureName: string): void {
        this._symbolSprite.texture = Loner.assetLoader.getTextures(textureName)[0];
        this.name = textureName;
        this._burnTextureName = this.name + "_burn";
    }

    public getSymbolShotTL(): gsap.core.Timeline {
        const symbolShotTL: gsap.core.Timeline = gsap.timeline();
        symbolShotTL.add(() => {
            this._explosionImage.visible = true;
            this._clipSpine.visible = false;
            this.isShot = true;
            this._multiplierValue = 0;
        });
        symbolShotTL.add(gsap.timeline({delay: 0.2}));
        symbolShotTL.add(() => {
            this._symbolSprite.visible = true;
            this.setSymbol(LonerDuckAnimator.DUCK_BASE_PATH +
                Loner.ssdMainView.getDuckValuePath(this._multiplierValue, this._symbolName) +
                LonerGameAssets.SSD_EXPLODED_DUCKS[MathHelper.randomIntInRange(0, LonerGameAssets.SSD_EXPLODED_DUCKS.length - 1)] +
                this.direction)
        });
        symbolShotTL.add(() => {
            this._explosionImage.visible = false
        });
        symbolShotTL.add(() => {
            this._multiplierText.visible = false
        });

        return symbolShotTL;
    }

    public reset(): void {
        this._clipSpine.visible = false;
        this._symbolSprite.visible = false;
    }
}